import actionTypes from '../actions/actionsFactory/types';

const {
  SET_REF_SWITCH_INFO, SET_REGISTER_OPEN_STATUS, SET_CHECK_IP_RESULT,
} = actionTypes;

export const INITIAL_STATE = {
  refSwitchInfo: {},
  isOpenRegister: true,
  isAllowedToRegister: true,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_REF_SWITCH_INFO:
      return { ...state, refSwitchInfo: action.data };
    case SET_REGISTER_OPEN_STATUS:
      return { ...state, isOpenRegister: action.data };
    case SET_CHECK_IP_RESULT:
      return { ...state, isAllowedToRegister: action.data };
    default:
      return state;
  }
};
